import React, { Suspense } from 'react'
import { useRoutes } from 'react-router-dom'
import Layout from './layout/Layout'
import Overview from './pages/dashboard/Overview'
import ProfileLayout from './layout/ProfileLayout'
import Login from './auth/Login'
import PrivateRoute from './utils/PrivateRoute'
import Index from './pages/addSite.jsx/Index'
import SiteDetailsRoute from './utils/SiteDetailsRoute'
import SelectSite from './context/SelectSite'
import SelectSitePage from './pages/SelectSitePage'
import ChangePassword from './auth/ChangePassword'
import LandingLayout from './layout/LandingLayout'
import Home from './pages/ladingPage/Home'
import PageNotFound from './component/PageNotFound'

const Wallet = React.lazy(() => import('./pages/account/Wallet'));
const Payment = React.lazy(() => import('./pages/Payment'));
const PushViaForm = React.lazy(() => import('./pages/pushnotification/PushViaForm'));
const CreateSegment = React.lazy(() => import('./pages/users/CreateSegment'));
const Plans = React.lazy(() => import('./pages/billing/Plans'));
const TeamMembers = React.lazy(() => import('./pages/account/TeamMembers'));
const Profile = React.lazy(() => import('./pages/account/Profile'));
const ContactUs = React.lazy(() => import('./pages/ContactUs'));
const TrustAndPrivacy = React.lazy(() => import('./pages/TrustAndPrivacy'));
const PublicKeyAMP = React.lazy(() => import('./pages/integration/PublicKeyAMP'));
const ManualIntegration = React.lazy(() => import('./pages/integration/ManualIntegration'));
const CustomAttributes = React.lazy(() => import('./pages/logs/CustomAttributes'));
const TrackingCode = React.lazy(() => import('./pages/setup/TrackingCode'));
const SiteSettings = React.lazy(() => import('./pages/setup/SiteSettings'));
const WelcomePush = React.lazy(() => import('./pages/setup/WelcomePush'));
const SubscriptionBell = React.lazy(() => import('./pages/setup/SubscriptionBell'));
const OptINPrompt = React.lazy(() => import('./pages/setup/OptINPrompt'));
const PushViaApi = React.lazy(() => import('./pages/pushnotification/PushViaApi'));
const ManualPush = React.lazy(() => import('./pages/pushnotification/ManualPush'));
const AllUsers = React.lazy(() => import('./pages/users/AllUsers'));
const GeoReport = React.lazy(() => import('./pages/dashboard/GeoReport'));
const ForgetPassword = React.lazy(() => import('./auth/ForgetPassword'));
const Register = React.lazy(() => import('./auth/Register'));
// const Home = React.lazy(() => import('./pages/ladingPage/Home'));
const Pricing = React.lazy(() => import('./pages/ladingPage/Pricing'));
// const LandingLayout = React.lazy(() => import('./layout/LandingLayout'));


export default function Routes() {
    return useRoutes([
        {
            path: "/auth",
            children: [
                {
                    path: 'login', element: <Login />
                },
                {
                    path: 'register', element: <Suspense fallback={<div>Loading...</div>}> <Register /> </Suspense>
                },
                {
                    path: 'forgot-password', element: <Suspense fallback={<div>Loading...</div>}> <ForgetPassword /> </Suspense>
                },
                {
                    path: 'change-password/:id', element: <ChangePassword />
                }
            ]
        },
        {
            path: "/",
            element: <LandingLayout />,
            children: [
                {
                    path: '', element: <Home />
                },
                {
                    path: 'pricing', element: <Suspense fallback={<div>Loading...</div>}> <Pricing /> </Suspense>
                }
            ]
        },
        {
            path: "/dashboard",
            element: <PrivateRoute> <SiteDetailsRoute> <SelectSite> <Layout /> </SelectSite> </SiteDetailsRoute>  </PrivateRoute>,
            children: [
                {
                    path: "overview", element: <Overview />
                },
                {
                    path: "geo-report", element: <Suspense fallback={<div>Loading...</div>}> <GeoReport /> </Suspense>
                },
                {
                    path: "all-users", element: <Suspense fallback={<div>Loading...</div>}> <AllUsers /> </Suspense>
                },
                {
                    path: "create-segments", element: <Suspense fallback={<div>Loading...</div>}> <CreateSegment /> </Suspense>
                },
                {
                    path: "campaigns/manual", element: <Suspense fallback={<div>Loading...</div>}> <ManualPush /> </Suspense>
                },
                {
                    path: "campaigns/api", element: <Suspense fallback={<div>Loading...</div>}> <PushViaApi /> </Suspense>
                },
                {
                    path: "campaigns/form", element: <Suspense fallback={<div>Loading...</div>}> <PushViaForm /> </Suspense>
                },
                {
                    path: "optin", element: <Suspense fallback={<div>Loading...</div>}> <OptINPrompt /> </Suspense>
                },
                {
                    path: "subscription-bell", element: <Suspense fallback={<div>Loading...</div>}> <SubscriptionBell /> </Suspense>
                },
                {
                    path: "welcome-push", element: <Suspense fallback={<div>Loading...</div>}> <WelcomePush /> </Suspense>
                },
                {
                    path: "site-setting", element: <Suspense fallback={<div>Loading...</div>}> <SiteSettings /> </Suspense>
                },
                {
                    path: "tracking-code", element: <Suspense fallback={<div>Loading...</div>}> <TrackingCode /> </Suspense>
                },
                {
                    path: "data-and-privacy", element: <Suspense fallback={<div>Loading...</div>}> <TrustAndPrivacy /> </Suspense>
                },
                {
                    path: "contact-us", element: <Suspense fallback={<div>Loading...</div>}> <ContactUs /> </Suspense>
                },
                {
                    path: "payment/:id/:id", element: <Suspense fallback={<div>Loading...</div>}> <Payment /> </Suspense>
                },
            ]
        },
        {
            path: "/dashboard/logs",
            element: <PrivateRoute> <SiteDetailsRoute>  <SelectSite>  <Layout /> </SelectSite>  </SiteDetailsRoute>  </PrivateRoute>,
            children: [
                {
                    path: "attributes", element: <Suspense fallback={<div>Loading...</div>}> <CustomAttributes /> </Suspense>
                }
            ]
        },
        {
            path: "/dashboard/integration",
            element: <PrivateRoute> <SiteDetailsRoute>   <SelectSite> <Layout /> </SelectSite> </SiteDetailsRoute>  </PrivateRoute>,
            children: [
                {
                    path: "manual", element: <Suspense fallback={<div>Loading...</div>}> <ManualIntegration /> </Suspense>
                },
                {
                    path: "amp-key", element: <Suspense fallback={<div>Loading...</div>}> <PublicKeyAMP /> </Suspense>
                }
            ]
        },
        {
            path: "/account",
            element: <PrivateRoute> <SiteDetailsRoute>  <SelectSite> <ProfileLayout /> </SelectSite> </SiteDetailsRoute> </PrivateRoute>,
            children: [
                {
                    path: "profile", element: <Suspense fallback={<div>Loading...</div>}> <Profile /> </Suspense>
                },
                {
                    path: "team-members", element: <Suspense fallback={<div>Loading...</div>}> <TeamMembers /> </Suspense>
                },
                {
                    path: "plans", element: <Suspense fallback={<div>Loading...</div>}> <Plans /> </Suspense>
                },
                {
                    path: "add-site", element: <Index />
                },
                {
                    path: "select-site", element: <SelectSitePage />
                },
                {
                    path: "wallet", element: <Suspense fallback={<div>Loading...</div>}> <Wallet /> </Suspense>
                },
            ]
        },
        {
            path: "*", element: <PageNotFound />
        }
    ])
}
